export enum RelationshipToContact {    
    MySpouse = 4,
    MyParent = 5,
    MyChild = 6,
    MySibling = 7,
    Friend = 2,
    AnAcquaintance = 8,
    SocialMedia = 3,
    Other = 9,
    FamilyMember = 10
}